<template>
  <div>
    <h2>{{ $t('playerModal.title') }}</h2>
    <p>{{ $t('playerModal.subheader')}}</p>
    <div v-if="modalMsg" class="alert alert-info">
      {{ modalMsg }}
    </div>
    <div
      class="radio-group"
    >
      <template

        v-for="player in availablePlayers"
        :key="player.id">

        <input
          class="form-check-input"
          type="radio"
          :id="'radioPlayer' + player.id"
          :value="player"
          v-model="selectedPlayer"
          name="playerOptions"
        />
        <label
          class="form-check-label"
          :for="'radioPlayer' + player.id"
        >
          {{ usePlayerNames ? shortName(player.name) : player.number }} ({{ player.gender }})
        </label>
      </template>
    </div>
    <div class="mt-3 d-flex gap-3">
      <button @click="confirmSelection" class="btn btn-bb5-yellow w-100 m-0 p-2 my-2">{{ $t('confirm') }}
      </button>
    </div>
  </div>
</template>

<script>

import core from '@/mixins/Core';

export default {
  props: {
    availablePlayers: {
      type: Array,
      required: true
    },
    modalMsg: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      selectedPlayer: null, // To track the selected player
      strickMode: true
    };
  },
  mixins: [core],
  methods: {
    confirmSelection() {
      if (this.selectedPlayer) {
        this.$emit('special-case', this.selectedPlayer );
      } else {
        alert(this.$t('substitute.alert'));
      }
    },
  }
};
</script>

<style scoped>
.radio-group {
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 15px;
  margin-top: 20px;
  width: 100%
}

.radio-group label {
  display: inline-block;
  cursor: pointer;
  padding: 10px 20px;
  font-size: 16px;
  border: 1px solid #000;
  border-radius: 8px;
  background-color: #fff;
  color: #000;
  position: relative;
  transition: all 0.3s ease;
  text-align: center;
  user-select: none;
}

.radio-group input[type="radio"] {
  display: none;
}

.radio-group label::after {
  content: '✓';
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%) scale(0);
  font-size: 24px;
  font-weight: 800;
  color: #fff;
  transition: transform 0.2s ease;
}

.radio-group input[type="radio"]:checked + label {
  background-color: var(--bb5-yellow);
  color: #000;
  border-color: var(--bb5-yellow);
}

.radio-group input[type="radio"]:checked + label::after {
  transform: translateY(-50%) scale(1);
}

.radio-group label:hover {
  background-color: #ddd;
  border-color: #aaa;
}
</style>

